<template>
  <button
    type="button"
    v-bind="$attrs"
    class="
      relative
      inline-flex
      items-center
      w-auto
      text-blue
      font-bold
      transition-colors
      duration-300
      hover:text-blue-hover
      focus:outline-none
    "
  >
    <slot />
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-6 w-6 ml-1 mt-3px lg:mt-1px"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M19 9l-7 7-7-7"
      />
    </svg>
  </button>
</template>
